import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, Subject, catchError, filter, interval, of, switchMap, takeUntil, tap } from "rxjs";
import { appActions, fromApp, RootState } from "../../store";
import { HealthService } from "../../services/api";

@Component({
  selector: "app-server-down",
  templateUrl: "./server-down.component.html",
  styleUrls: ["./server-down.component.scss"],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServerDownComponent implements OnInit, OnDestroy {
  public readonly serverDown$: Observable<boolean> = this.store.select(fromApp.selectServerDown);

  private readonly $unsubscribeAll = new Subject<void>();

  constructor(
    private readonly store: Store<RootState>,
    private readonly healthService: HealthService,
  ) {}

  public ngOnInit(): void {
    this.serverDown$
      .pipe(
        filter(down => down),
        switchMap(() =>
          interval(5000).pipe(
            switchMap(() => this.performHealthCheck()),
            takeUntil(this.serverDown$.pipe(filter(down => !down))),
          ),
        ),
        takeUntil(this.$unsubscribeAll),
      )
      .subscribe();
  }

  public ngOnDestroy(): void {
    this.$unsubscribeAll.next();
    this.$unsubscribeAll.complete();
  }

  public retryNow(): void {
    this.performHealthCheck(true).pipe(takeUntil(this.$unsubscribeAll)).subscribe();
  }

  // Failed checks only keep the notice; a successful one hands over to AppEffects, which reloads the app.
  private performHealthCheck(manual = false): Observable<unknown> {
    return this.healthService.healthControllerCheck().pipe(
      tap(() => this.store.dispatch(appActions.serverRecovered({ manual }))),
      catchError(() => of(null)),
    );
  }
}
